import "./index.css";
import { icons } from "./utils";

type TArg = {
  type?: "success" | "error" | "warning";
  title: string;
  interval?: number;
};

const buildToast = (arg: TArg) => {
  const { title, type = "success" } = arg;

  return `
        <div class='${type}'>
            <div class="icon">
                ${
                  type === "success"
                    ? icons.success
                    : type === "error"
                    ? icons.error
                    : icons.warning
                }
            </div>
            <div class="text">
                ${title}
            </div>
        </div>
    `;
};

const useToast = () => (arg: TArg) => {
  const body = document.querySelector("body") as HTMLBodyElement;
  const { interval = 5000 } = arg;

  const el = document.createElement("div");
  el.className = "toast";
  el.innerHTML = buildToast(arg);

  body.appendChild(el);

  setTimeout(() => {
    body.removeChild(el);
  }, interval);
};

export default useToast;
